module.exports = __webpack_public_path__ + "static/media/logo-white.6a520331.svg";